import outmazedLogo from '../../assets/footerLogo.svg';
import { PAGE_URL } from '../../config/appConfig';
export const getHeaderData = () => {
  return [


    {
      label: 'ABOUT US',
      href: PAGE_URL.ABOUT,
    },

    {
      label: 'SERVICES',
      href: PAGE_URL.SERVICE,
    },
    {
      label: 'PROJECTS',
      href: PAGE_URL.PROJECTS,
    },
    // {
    //   label: 'BEFORE AFTER',
    //   href: PAGE_URL.BEFORE_AFTER,
    // },
    {
      label: '',
      image: outmazedLogo,
      href: PAGE_URL.HOMEPAGE,
    },

    {
      label: 'OUR BRANDS',
      href: PAGE_URL.OUR_BRANDS,
      children: [
        { label: 'OutMazed Design', href: PAGE_URL.COMING_SOON },
        { label: 'OutMazed Design (Pools & Landscape)', href: PAGE_URL.COMING_SOON },
        { label: 'Build Up by OutMazed & Partners', href: 'https://outmazeddesign.ae/buildup' },

      ]
    },
    {
      label: 'INNOVATION',
      children: [
        { label: 'Customized cabinetry works', href: PAGE_URL.COMING_SOON },
        { label: 'Smart frosting', href: PAGE_URL.COMING_SOON },
        { label: 'Architectural wraps', href: PAGE_URL.COMING_SOON },
        { label: 'Net screens pleated system (Retractable & Concealed)', href: PAGE_URL.COMING_SOON },
        { label: 'Nest thermostats', href: PAGE_URL.COMING_SOON },
        { label: 'Fibre glass pools', href: PAGE_URL.COMING_SOON },
        { label: 'Cabins & pods', href: PAGE_URL.COMING_SOON },
        { label: 'Sauna (Indoors & Outdoors)', href: PAGE_URL.COMING_SOON },
        { label: 'Home Automation', href: PAGE_URL.COMING_SOON },
        { label: 'THEMES', href: PAGE_URL.THEME },

      ]
    },
    // {
    //   label: 'CAREERS',
    //   href: PAGE_URL.CAREERS,
    // },
    {
      label: 'CONTACT US',
      href: PAGE_URL.CONTACT_US,
    },
  ];
};
